import React from 'react';

export const StaticImageBackground: React.FC = () => {
  return (
    <div className="absolute inset-0 z-0">
      {/* Overlay escuro */}
      <div className="absolute inset-0 bg-black/60 z-10" />
      
      {/* Imagem de Background (responsiva) */}
      <picture className="absolute inset-0">
        <source media="(max-width: 768px)" srcSet="/images/hero-background-mobile.jpg" />
        <img
          src="/images/hero-background.jpg"
          alt="Background"
          className="w-full h-full object-cover"
        />
      </picture>
    </div>
  );
};

export default StaticImageBackground;
